module.exports = __webpack_public_path__ + "img/logo.834369e8.svg";